import { useInfiniteQuery } from '@tanstack/react-query';
import { individualsService, IndividualStatus, useToast } from '@aslanpay/portal-common-lib';

import { IndividualPage } from 'app/components/UI/Table/Table.types';

const PAGE_SIZE = 50;

const useInfiniteFetchEmployees = ({
  companyId,
  status,
  onUnpaidLeave,
  query,
  size = PAGE_SIZE,
  sort,
  sortBy,
  enabled = true,
}: {
  companyId?: string;
  status?: IndividualStatus[];
  onUnpaidLeave?: boolean;
  query?: string;
  size?: number;
  sort?: 'ASC' | 'DESC';
  sortBy?: string;
  enabled?: boolean;
}) => {
  const toast = useToast();

  return useInfiniteQuery<IndividualPage, Error>(
    ['infiniteFetchEmployees', companyId, status, onUnpaidLeave, query, sort, sortBy],
    async ({ pageParam = 0 }) => {
      const employees = await individualsService.fetchIndividuals({
        role: ['EMPLOYEE'],
        status,
        onUnpaidLeave,
        companyId: companyId ? [companyId] : undefined,
        page: pageParam,
        query,
        size,
        sort,
        sortBy,
      });

      return employees;
    },
    {
      getNextPageParam: (lastPage, pages) => {
        const hasMore = lastPage.list.length === size;
        return hasMore ? pages.length : undefined;
      },
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Failed to load employees',
          description: 'Please try again later.',
        });
      },
      enabled: enabled && !!companyId,
    }
  );
};

export default useInfiniteFetchEmployees;
